<template>
  <div id="educationView">
    <van-pullRefresh v-model="detail.refreshing" @refresh="init()">
      <Empty v-if="detail.totalCount === 0" />
      <van-List
        v-else
        v-model="detail.loading"
        :finished="detail.finished"
        @load="onLoad"
      >
        <EducationViewItem v-for="item in detail.list" :key="item.id" :item="item" @click="handleItem('EducationViewDetail',item.id)" />
        <template #finished>
          <van-divider class="list-bottom-tip">滑到底啦</van-divider>
        </template>
      </van-List>
    </van-pullRefresh>
  </div>
</template>

<script>
import EducationViewItem from './components/EducationViewItem';
export default {
  name: 'EducationView',
  components: { EducationViewItem },
  data () {
    return {
      detail: {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      },
      id: ''
    };
  },
  created () {
    this.id = this.$route.params.id;
    this.$route.meta.title = this.$route.query.title;
  },
  methods: {
    init () {
      this.detail = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      };
    },
    onLoad () {

      const { detail, id } = this;
      this.$http.get('courseTeach/horizon/list', {
        params: {
          pageNo: detail.pageNo,
          pageSize: detail.pageSize,
          id
        }
      }).then((res) => {
        const data = res.data.page || {};
        detail.list.push(...(data.result || []));
        detail.pageNo++;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
        detail.refreshing = false;
      });
    },
    handleItem (name, id) {
      this.$router.push({ name, params: { id } });
    }
  }
};
</script>

<style lang="less" scoped>

</style>